<template>
  <div :id="uuid" :style="{ width: width + 'px', height: height + 'px' }" />
</template>

<script setup>
import { getDataJson, pollingRefresh, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";
import { onMounted, watch, computed } from "vue";
import * as echarts from 'echarts'

const props = defineProps({
  width: Number,
  height: Number,
  option: Object,
  current: Object,
  show: Boolean,
  components: Array,
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow, (val) => {
  if (val && dataReload.value.includes(1)) {
    refreshCptData();
  }
})
watch(() => props.option.attribute.hideCompInTabw, (val) => {
  if (!val && dataReload.value.includes(1)) {
    refreshCptData();
  }
})
watch(() => props.option.attribute, (obj) => {
  console.log(obj, 'objobjobj')
  if (obj.dataZoom && obj.dataZoom.show) {
    obj.grid.y2 = obj.grid.y2 == 30 ? 50 : obj.grid.y2;
  } else {
    obj.grid.y2 = obj.grid.y2 == 50 && obj.grid.y2 != 30 ? 30 : obj.grid.y2;
  }
  processData(props.option.cptDataForm, newData, jsFunFlag)
  loadChart(obj);
}, { deep: true })
watch(() => [props.width, props.height], () => {
  chart.resize()
})

let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = [];
let newData = "";
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

onMounted(() => {
  if (document.getElementById(uuid)) {
    chart = echarts.init(document.getElementById(uuid))
    if (dataReload.value.includes(0)) {
      refreshCptData();
    }
  }
})

function refreshCptData(cptDataForm = props.option.cptDataForm, paras) {
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm, paras),
    props.components)
}
function loadData(cptDataForm, paras) {
  getDataJson(cptDataForm, paras, (res) => {
    // cptData = res;
    newData = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
    jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
    processData(cptDataForm, newData, jsFunFlag)
    loadChart(props.option.attribute);
  })
}
function processData(cptDataForm, res, jsFunFlag) {
  // 第一层判断 如果选择数据集
  console.log(res, 'asd56677')
  if (cptDataForm.dataSource == '4') {
    // 第二层判断 ，如果没有配转换脚本
    if (jsFunFlag) { // 没有全部配置映射字段
      if (hasNonEmptyValues(props.option.attribute.cptTableData)) {
        const dataKey = props.option.attribute.cptTableData;
        console.log(dataKey, 'dataKey')
        let groupData = {};
        console.log(res, 'res')
        res.forEach(item => {
          let group = item[dataKey[0].value];
          let name = item[dataKey[1].value];
          let value = item[dataKey[2].value];

          if (!groupData[group]) {
            groupData[group] = { group, data: [] };
          }
          groupData[group].data.push({ name, value });
        });

        // 将 groupData 转换为 newarr 数组形式
        let newarr = Object.values(groupData).map(groupItem => ({
          ...groupItem,
        }));
        console.log(newarr, '新数组')
        cptData = newarr;
      }
    } else { // 如果配置了转换脚本
      cptData = res;
    }
  } else { // 不是数据集类型，是静态数据
    cptData = res;
  }
}
function loadChart(attribute) {
  const attr = JSON.parse(JSON.stringify(attribute));
  let xAisData = [];
  // if(!cptData[0]) {
  //   return
  // }
  cptData[0]?.data.forEach(item => {
    xAisData.push(item.name)
  })

  console.log(cptData[0]?.data, 'qwdokjqdoqwoqkodqokdwqkod');
  // 根据范围渲染数据
  let yAxisDataList = cptData[0]?.data.map(item => item.value) || [0]
  let minValue = Math.min(...yAxisDataList)
  let maxValue = Math.max(...yAxisDataList)
  minValue = minValue ? minValue : 0
  maxValue = maxValue ? maxValue : 0
  console.log(minValue, maxValue,'qwdijqiwjiqwjidiq')
  // let padding = (maxValue - minValue) * 0.5
  let padding = maxValue * 0.5
  let yAxis = { ...attr.yAxis, type: 'value'}
  if(attr.yAxisRangeRender) {
    // yAxis['min'] = Math.floor(minValue.toFixed(1))
    // yAxis['max'] = Math.ceil(maxValue.toFixed(1))
    // yAxis['min'] = minValue <  1 ? (minValue - 0.05).toFixed(1) : Math.floor(minValue.toFixed(1))
    // yAxis['max'] = maxValue < 1 ? (maxValue + 0.05).toFixed(1) : Math.ceil(maxValue.toFixed(1))

  
    yAxis['min'] = minValue < 1 ? (minValue * 0.95).toFixed(1) : (minValue * 0.98).toFixed(1)
    yAxis['max'] = maxValue < 1 ? (maxValue * 1.05).toFixed(1) : (maxValue * 1.02).toFixed(1)
    
  }

  chartOption = {
    color: attr.lineColors,
    title: attr.title,
    grid: Object.assign(attr.grid, { containLabel: true }),
    xAxis: Object.assign(attr.xAxis, { type: 'category', data: xAisData }),
    yAxis: yAxis,
    tooltip: {
      ...attr.tooltip,
    },
    legend: attr.legend,
    dataZoom: attr.dataZoom,
  }
  chartOption.series = [];
  for (let i = 0; i < cptData.length; i++) {
    const item = cptData[i]
    let data = []
    item.data.forEach(column => {
      data[xAisData.indexOf(column.name)] = column.value
    })
    console.log(data,'datadatadatadatadata');
    chartOption.series.push({
      name: item.group,
      data: data,
      type: 'line',
      symbol: 'circle',//折线点设置为实心点
      symbolSize: attr.symbolSize,
      smooth: attr.smooth,//平滑曲线
      areaStyle: {
        color: attr.areaColors[i],
        opacity: attr.areaShow ? 1 : 0
      },
      lineStyle: {
        opacity: attr.lineShow ? 1 : 0
      },
      label: attr.series ? attr.series.label : null
    })
  }
  chart && chart?.setOption(chartOption, true);
  chart && chart?.on('click', (params) => {
    emit("clickHandler", props.option.interaction, 'default', params.name)
  })
}

defineExpose({
  refreshCptData, processData,
  current: props.current
})
</script>

<style scoped></style>
